<template>
  <div>
    <p class="page-container">
      没有找到你要的页面<br />你是不是迷路了?
      <el-button @click="goback()" type="text">重新登录</el-button>
    </p>
  </div>
</template>
<style scoped>
.page-container {
  font-size: 25px;
  text-align: center;
  color: rgb(192, 204, 218);
}
.router-link-active {
  font-size: 14px;
}
</style>
<script>
export default {
  components: {},
  directives: {},
  data() {
    return {};
  },
  created() {},
  methods: {
    goback() {
      this.$router.push('/')
    },
  },
};
</script>
